import { combineReducers } from 'redux';
import AuthReducer from './AuthReducer';
import UserReducer from "./UserReducer";
import PermissionReducer from "./PermissionReducer";
import RoleReducer from "./RoleReducer";
import ConfigReducer from "./ConfigReducer";
import ServiceReducer from './ServiceReducer';
import CustomerClassReducer from './CustomerClassReducer';
import CustomerStatusReducer from './CustomerStatusReducer';
import CustomerInteractiveStatusReducer from './CustomerInteractiveStatusReducer';
import CustomerInteractiveTypeReducer from './CustomerInteractiveTypeReducer';
import LookupCustomerReducer from './LookupCustomerReducer';
import PageManagerReducer from './PageManagerReducer';
import RegionsReducer from './RegionsReducer';
import BranchReducer from './BranchReducer'
import RoleGroupReducer from './RoleGroupReducer';
import ListDiseasesReducer from './ListDiseasesReducer';
import BloodTypeReducer from './BloodTypeReducer';
import CustomerScheduleReducer from './CustomerScheduleReducer';
import CashReceiptReducer from './CashReceiptReducer';
import ProductReducer from './ProductReducer';
import VoucherReducer from './VoucherReducer';
import ProductGroupReducer from './ProductGroupReducer';
import ProductSupplierReducer from './ProductSupplierReducer';
import ProductWarehouseReducer from './ProductWarehouseReducer';
import ProductReceiptImportReducer from './ProductReceiptImportReducer';
import CustomerSourceReducer from './CustomerSourceReducer';
import ProductReceiptExportReducer from './ProductReceiptExportReducer';
import UnitReducer from './UnitReducer';
import GuideReducer from './GuideReducer';
import WorkReportReducer from './WorkReportReducer';
import TelegramReducer from './TelegramReducer';
import ProductStatusReducer from './ProductStatusReducer';
import CustomerTelesaleReducer from './CustomerTelesaleReducer';
import CustomerConsultantDirectReducer from './CustomerConsultantDirectReducer';
import CustomerPotentialReducer from './CustomerPotentialReducer';
import PaymentVoucherReducer from './PaymentVoucherReducer';
import RewardSpinReducer from './RewardSpinReducer';
import PostsReducer from './PostsReducer';
import ViewPhonenumberReducer from './ViewPhonenumberReducer';
import notificationsReducer from './notificationsReducer';
import ProjectReducer from './ProjectReducer';
import ProjectBasedJobReducer from './ProjectBasedJobReducer';
import DoctorAssistantStatusReducer from './DoctorAssistantStatusReducer';
import DentalPatientCasesReducer from './DentalPatientCasesReducer';
import FunctionalAreaReducer from './FunctionalAreaReducer';
import FunctionalReducer from './FunctionalReducer';
import JobsReducer from './JobsReducer';
import ShiftSchedulingReducer from './ShiftSchedulingReducer';
import CustomerMedicalReducer from './CustomerMedicalReducer';
import CashBookReducer from './CashBookReducer';
import CustDocAssistReducer from './CustDocAssistReducer';
import CardTypeReducer from './CardTypeReducer';
import CardReleaseTrackingReducer from './CardReleaseTrackingReducer';
import CardIssuedCountReducer from './CardIssuedCountReducer';
import CardPendingCustomerReducer from './CardPendingCustomerReducer';
import CustomerServicesReducer from './CustomerServicesReducer';
import AssistantReducer from './AssistantReducer';
import DoctorReducer from './DoctorReducer';
import statisticsReducer from './statisticsReducer';
import RelationshipTypeReducer from './RelationshipTypeReducer';
import MediaReducer from './MediaReducer';
import MediaLibraryReducer from './MediaLibraryReducer';
import MediaCategoriesReducer from './MediaCategoriesReducer';
import DocumentCategories from './DocumentCategories';
import Documents from './Documents';
import CustomerGroup from './CustomerGroup';
import CommissionRule from './CommissionRule';
import CommissionRevenue from './CommissionRevenue';
import Commission from './Commission';
import Zalo from './Zalo';
import auditLogReducer from './auditLogReducer';
import laboReducer from '@/redux/reducers/laboReducer';
import laboCaseReducer from '@/redux/reducers/laboCaseReducer';
import feedbackRequestReducer from '@/redux/reducers/feedbackRequestReducer';
import customerReducer from '@/redux/reducers/customerReducer';
import treatmentNoteReducer from './treatmentNoteReducer';
import BranchFundReducer from './BranchFundReducer';
import procedureReducer from './procedureReducer';
import filterReducer from './filterReducer';
import orthodonticPlanReducer from './orthodonticPlanReducer';
import cusServiceMilestoneReducer from './cusServiceMilestoneReducer';
import instructionTemplateReducer from './instructionTemplateReducer';
import prescriptionTemplateReducer from './prescriptionTemplateReducer';
import treatmentSessionReducer from './treatmentSessionReducer';
import generalExamReducer from './generalExamReducer';
import orthodonticExamReducer from './orthodonticExamReducer';
import customerCareCategoryReducer from './customerCareCategoryReducer';
import customerCareLogReducer from './customerCareLogReducer';
import customerComplaintReducer from './customerComplaintReducer';
import monitoringReducer from './monitoringReducer';
import telesaleFollowUpReducer from './telesaleFollowUpReducer';
import partnerCustomerReducer from './partnerCustomerReducer';
import doctorCustomerReducer from './doctorCustomerReducer';
import doctorAppointmentReducer from './doctorAppointmentReducer';

const rootReducer = combineReducers({
    auth: AuthReducer,
    user: UserReducer,
    permission: PermissionReducer,
    role: RoleReducer,
    config: ConfigReducer,
    ServiceReducer: ServiceReducer,
    customerReducer: customerReducer,
    LookupCustomerReducer: LookupCustomerReducer,
    CustomerClassReducer: CustomerClassReducer,
    CustomerStatusReducer: CustomerStatusReducer,
    CustomerInteractiveStatusReducer: CustomerInteractiveStatusReducer,
    CustomerInteractiveTypeReducer: CustomerInteractiveTypeReducer,
    PageManagerReducer: PageManagerReducer,
    RegionsReducer: RegionsReducer,
    BranchReducer: BranchReducer,
    RoleGroupReducer: RoleGroupReducer,
    ListDiseasesReducer: ListDiseasesReducer,
    BloodTypeReducer: BloodTypeReducer,
    CustomerScheduleReducer: CustomerScheduleReducer,
    CashReceiptReducer: CashReceiptReducer,
    ProductReducer: ProductReducer,
    VoucherReducer: VoucherReducer,
    ProductGroupReducer: ProductGroupReducer,
    ProductSupplierReducer: ProductSupplierReducer,
    ProductWarehouseReducer: ProductWarehouseReducer,
    ProductReceiptImportReducer: ProductReceiptImportReducer,
    CustomerSourceReducer: CustomerSourceReducer,
    ProductReceiptExportReducer: ProductReceiptExportReducer,
    UnitReducer: UnitReducer,
    WorkReportReducer: WorkReportReducer,
    Guide: GuideReducer,
    TelegramReducer: TelegramReducer,
    ProductStatusReducer: ProductStatusReducer,
    CustomerTelesaleReducer: CustomerTelesaleReducer,
    CustomerConsultantDirectReducer: CustomerConsultantDirectReducer,
    CustomerPotentialReducer: CustomerPotentialReducer,
    PaymentVoucherReducer: PaymentVoucherReducer,
    RewardSpinReducer: RewardSpinReducer,
    PostsReducer: PostsReducer,
    ViewPhonenumberReducer: ViewPhonenumberReducer,
    notificationsReducer: notificationsReducer,
    ProjectReducer: ProjectReducer,
    ProjectBasedJobReducer: ProjectBasedJobReducer,
    DoctorAssistantStatusReducer: DoctorAssistantStatusReducer,
    DentalPatientCasesReducer: DentalPatientCasesReducer,
    FunctionalAreaReducer: FunctionalAreaReducer,
    FunctionalReducer: FunctionalReducer,
    JobsReducer: JobsReducer,
    ShiftSchedulingReducer: ShiftSchedulingReducer,
    CustomerMedicalReducer: CustomerMedicalReducer,
    CashBookReducer: CashBookReducer,
    CustDocAssistReducer: CustDocAssistReducer,
    CardTypeReducer: CardTypeReducer,
    CardReleaseTrackingReducer: CardReleaseTrackingReducer,
    CardIssuedCountReducer: CardIssuedCountReducer,
    CardPendingCustomerReducer: CardPendingCustomerReducer,
    CustomerServicesReducer: CustomerServicesReducer,
    AssistantReducer: AssistantReducer,
    DoctorReducer: DoctorReducer,
    statisticsReducer: statisticsReducer,
    RelationshipTypeReducer: RelationshipTypeReducer,
    MediaReducer: MediaReducer,
    MediaLibraryReducer: MediaLibraryReducer,
    MediaCategoriesReducer: MediaCategoriesReducer,
    DocumentCategories: DocumentCategories,
    Documents: Documents,
    CustomerGroup: CustomerGroup,
    CommissionRule: CommissionRule,
    CommissionRevenue: CommissionRevenue,
    Commission: Commission,
    Zalo: Zalo,
    auditLogReducer: auditLogReducer,
    laboReducer: laboReducer,
    laboCaseReducer: laboCaseReducer,
    feedbackRequestReducer: feedbackRequestReducer,
    treatmentNoteReducer: treatmentNoteReducer,
    BranchFundReducer: BranchFundReducer,
    procedureReducer: procedureReducer,
    filterReducer: filterReducer,
    orthodonticPlanReducer: orthodonticPlanReducer,
    cusServiceMilestoneReducer: cusServiceMilestoneReducer,
    instructionTemplateReducer: instructionTemplateReducer,
    prescriptionTemplateReducer: prescriptionTemplateReducer,
    treatmentSessionReducer: treatmentSessionReducer,
    generalExamReducer: generalExamReducer,
    orthodonticExamReducer: orthodonticExamReducer,
    customerCareCategoryReducer: customerCareCategoryReducer,
    customerCareLogReducer: customerCareLogReducer,
    customerComplaintReducer: customerComplaintReducer,
    monitoringReducer: monitoringReducer,
    telesaleFollowUpReducer: telesaleFollowUpReducer,
    partnerCustomerReducer: partnerCustomerReducer,
    doctorCustomerReducer: doctorCustomerReducer,
    doctorAppointmentReducer: doctorAppointmentReducer
});

export default rootReducer;